<template >
    <div>
        <div class="flex items-center justify-between">
            <breadcrumbs>Scrapers</breadcrumbs>
            <link-button :href="route('admin.keywords.index')" icon="cogs" class="bg-white">Preselection keywords</link-button>
        </div>

        <h1 class="text-5xl text-teal-800">
            Scrapers
        </h1>
        
        <table class="w-full whitespace-no-wrap bg-white rounded text-left">

            <thead>
                <tr class="text-teal-800 font-bold">
                    <th class="px-3 py-4 cursor-pointer" @click="sort('id')">
                        Name
                        <!-- <sort-icon col="name" :orderby="filters.orderBy" :sortorder="filters.sortOrder" /> -->
                    </th>
                    <th class="px-3 py-4">Last called</th>
                    <th class="px-3 py-4">Pages</th>
                    <th class="px-3 py-4">Job offers</th>
                    <!-- <td width="100">Jobs</td>
                    <td width="100">Completed</td>
                    <td width="100">Failed</td>
                    <td width="100">Remaining</td> -->
                    <!-- <th class="px-3 py-4"></th> -->

                </tr>
            </thead>
                    
            <tr v-for="(scraper, index) in scrapers" 
                :key="scraper.id" 
                class="hover:text-teal-900 hover:bg-teal-300 focus-within:bg-teal-300 :text-teal-900"
                :class="{'bg-teal-100': !(index % 2)}"
                >
                <td class="px-3 border-t">
                    <inertia-link class="py-4 flex items-center focus:font-bold" 
                        :href="route('admin.scrapers.show', scraper.id)" 
                        tabindex="-1" 
                    >
                        {{ scraper.name }}
                    </inertia-link>
                </td>

                <td class="px-3 border-t">
                    <inertia-link class="py-4 flex items-center focus:font-bold" 
                        :href="route('admin.scrapers.show', scraper.id)" 
                        tabindex="-1" 
                    >
                        <span v-if="scraper.last_called_at">{{ moment(scraper.last_called_at).fromNow(false) }}</span>
                    </inertia-link>
                </td>
                
                <td class="px-3 border-t">
                    <inertia-link class="hover:underline" 
                        :href="route('admin.scrapers.show', scraper.id)">{{ (scraper.numPages || 0) | numberFormatNL }}</inertia-link>
                </td>

                <td class="px-3 border-t">
                    <inertia-link class="hover:underline" 
                        :href="route('admin.joboffers.index')">{{ (scraper.numJobOffers || 0) | numberFormatNL }}</inertia-link>
                </td>

                <!-- <td class="px-3 border-t">{{ scraper.latestRun.jobs_dispatched }}</td>
                <td class="px-3 border-t">{{ scraper.latestRun.jobs_completed }}</td>
                <td class="px-3 border-t">{{ scraper.latestRun.jobs_failed }}</td>
                <td class="px-3 border-t">{{ scraper.latestRun.jobs_remaining }}</td> -->

                <!-- <td class="text-right pr-5 border-t">
                    <inertia-link class="hover:underline" 
                        :href="`/scrapers/${scraper.id}/scrape`">
                        <i class="fad fa-download mr-1"></i>
                    </inertia-link>
                </td> -->

            </tr>   

        </table>
    </div>    
</template>

<script>
    import Layout from '@/admin/Shared/Layout';
    import Breadcrumbs from '@/admin/Shared/Breadcrumbs';
    import LinkButton from "@/admin/Shared/LinkButton";

    export default {
        metaInfo: { title: 'Scrapers' },
        layout: Layout,
        components: {
            Breadcrumbs,
            LinkButton
        },
        props: {
            scrapers: {
                Type: Array
            },
        },
    }
</script>